import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import T from '../../Locale';
import ComponentModal from './ComponentModal';
import ComponentTitle from './ComponentTitle';
import ComponentListItem from './ComponentListItem';
import { fetchNotifications } from './Actions';
class ComponentList extends Component {
    componentDidMount() {
        this.props.dispatch(fetchNotifications());
    }
    render() {
        const { show, notifications, isLoading, link } = this.props;
        return (_jsxs("div", { children: [_jsx(ComponentModal, {}), _jsx(ComponentTitle, {}), _jsxs("div", Object.assign({ id: "notification-dropdown", className: `toolbar-notifications-content toolbar-dropdown ${show && 'toolbar-dropdown--open'}` }, { children: [_jsxs("ul", Object.assign({ className: "menu vertical" }, { children: [notifications.map((item) => (_jsx(ComponentListItem, { item: item }, item.id))), !isLoading && notifications.length > 0 && (_jsx("li", Object.assign({ className: "last" }, { children: _jsx("a", Object.assign({ href: link }, { children: T.translate('notifications.goToAll') })) })))] })), _jsxs("div", Object.assign({ className: "text-center" }, { children: [!isLoading || (_jsx("i", { className: "fas fa-spinner-third fa-spin loading" })), !isLoading && !notifications.length && (_jsx("p", Object.assign({ className: "empty" }, { children: T.translate('notifications.empty') })))] }))] }))] }));
    }
}
ComponentList.propTypes = {
    link: PropTypes.string.isRequired,
    isLoading: PropTypes.bool,
    notifications: PropTypes.array.isRequired,
    show: PropTypes.bool,
    dispatch: PropTypes.func,
    conditionsAccepted: PropTypes.bool
};
const mapStateToProps = (state) => ({
    isLoading: state.notifications.isLoading,
    notifications: state.notifications.items.slice(0, 5),
    show: typeof state.notifications.showItems === 'undefined' ? false : state.notifications.showItems,
    conditionsAccepted: !state.user || typeof state.user.conditionsAccepted === 'undefined' ? false : state.user.conditionsAccepted
});
export default connect(mapStateToProps)(ComponentList);
